import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { GenerateControlSheetsPoPComponent } from '../generate-control-sheets-po-p/generate-control-sheets-po-p.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-result-processing-one',
  templateUrl: './result-processing-one.component.html',
  styleUrls: ['./result-processing-one.component.scss']
})
export class ResultProcessingOneComponent implements OnInit {
  resultForm: FormGroup;
  resultSearchForm;
  gstrVldtMesg = '';
  MenuCode: string;
  submitButton = true;
  resultList = []
  isBranch = false;
  isDistrict = false;
  isGrace = false;
  isGraceClass = false;
  isGraceMaxPaper = false;
  filteredBranchDistrictList;
  BranchDistrictList;
  GLO_ShId;
  rollNo=false;
  // dynamic title diclaration 
  title = "Title Header"
  title_one = "Title one Header"
  title_two = "Title two Header"
  title_three = "Title three  Header"
  selectedRowValue: any;
  dialogRef: MatDialogRef<any>;
  SessionNo: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  Count: any;
  setIntervalSearch: any;
  RollNoPrfx: any;
  SessionYear: any;
  sessionList: any[] = [];
  filteredSessionList: any[] = [];

  // dynamic title diclaration 
  constructor(
    private route: ActivatedRoute, public umsService: UmsService,
    private modalPopupService: ModalpopService, private fb: FormBuilder,
    public router: Router, private httpClient: HttpClient, private dialog: MatDialog,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
   
    this.route.queryParams.subscribe(
      params => {
        window.scroll(0,0);
        this.MenuCode = params['MenuCode'];
        this.resultForm = this.fb.group({
          Exam: new FormControl('', Validators.required),
          branch: new FormControl(''),
          district: new FormControl(''),
          grace: new FormControl('', Validators.pattern("^[0-9]*$")),
          classGrace: new FormControl('', Validators.pattern("^[0-9]*$")),
          maxClassGrace: new FormControl('', Validators.pattern("^[0-9]*$")),
          RollNo : new FormControl(0, Validators.pattern("^[0-9]*$")),
          SessionId: new FormControl('', Validators.required),
        });
        if(JSON.parse(sessionStorage.getItem("session")) == null){
          this.fetchSecretData(this.MenuCode)
        }
        else if(JSON.parse(sessionStorage.getItem("session")) != null){
          let sessionData = JSON.parse(sessionStorage.getItem("session"));
          this.SessionNo = sessionData.SnNo;
          this.loadpage(this.MenuCode, this.SessionNo);
        }
        this.resultSearchForm = this.fb.group({
          SearchString: new FormControl('')
        })
        this.fetchSessionList();
      }
    )
  }
  fetchSessionList() {
    this.spinner.show();
    const payload = { SnActive: 'Y' };
    this.umsService.getSession(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.sessionList = res.data || [];
          this.filteredSessionList = [...this.sessionList];
          if (this.SessionNo) {
            const defaultSession = this.sessionList.find(s => s.SnNo == this.SessionNo);
            if (defaultSession) {
              this.resultForm.controls['SessionId'].setValue(this.SessionNo);
            } else if (this.sessionList.length > 0) {
            }
          }
        } else {
          this.sessionList = [];
          this.filteredSessionList = [];
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.sessionList = [];
        this.filteredSessionList = [];
      }
    });
  }
  onSessionChange(sessionId: any) {
    this.SessionNo = sessionId;
    this.resultForm.controls['SessionId'].setValue(sessionId);
    this.resetFormOnSessionChange();
    if (sessionId) {
      this.loadGrid(this.MenuCode, sessionId);
    } else {
      this.resultList = [];
      this.totalItems = 0;
    }
  }

  resetFormOnSessionChange() {
    this.resultForm.patchValue({
      Exam: '',
      branch: '',
      district: '',
      grace: '',
      classGrace: '',
      maxClassGrace: '',
      RollNo: 0,
    });
    this.BranchDistrictList = [];
    this.filteredBranchDistrictList = [];
    this.GLO_ShId = null;
    this.selectedRowValue = null;
    this.Count = 0;
  }

  fetchSecretData(MenuCode) {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      this.loadpage(MenuCode, this.SessionNo);
      this.SessionYear = res.projectPharam.SnYear;
      if (this.sessionList.length > 0) {
        const defaultSession = this.sessionList.find(s => s.SnNo == this.SessionNo);
        if (defaultSession) {
          this.resultForm.controls['SessionId'].setValue(this.SessionNo);
        }
      }
      }
    );
  }

  loadpage(e,SnNo) {
    if (e == 'O') {
      this.title = "Generate Roll-Numbers"
      this.title_one = "Generate Roll-Numbers "
      this.title_two = "This process can be repeated, WITH CARE "
      this.title_three = "IF Admit Cards / Roll List not Printed "
      this.isBranch = false;
      this.isDistrict = false;
      this.isGrace = false;
      this.isGraceClass = false;
      this.isGraceMaxPaper = false;
      this.rollNo = true;
      this.loadGrid(e,SnNo);

    } else if (e == 'C') {
      this.title = "Generate Control Sheets "
      this.title_one = "Generate Control Sheets "
      this.title_two = "This process can be repeated, if data Changes "
      this.title_three = ""
      this.isBranch = false;
      this.isDistrict = false;
      this.isGrace = false;
      this.isGraceClass = false;
      this.isGraceMaxPaper = false;
      this.rollNo = false;
      this.loadGrid(e,SnNo);
    } else if (e == 'D') {
      this.title = "Generate Codes "
      this.title_one = "Generate Codes"
      this.title_two = "This process can be repeated, if data Changes "
      this.title_three = ""
      this.isBranch = false;
      this.isDistrict = false;
      this.isGrace = false;
      this.isGraceClass = false;
      this.isGraceMaxPaper = false;
      this.rollNo = false;
      this.loadGrid(e,SnNo);
    } else if (e == 'F') {
      this.title = "Generate Mark-Foils "
      this.title_one = "Generate Mark-Foils "
      this.title_two = "This process can be repeated, if data Changes "
      this.title_three = ""
      this.isBranch = false;
      this.isDistrict = false;
      this.isGrace = false;
      this.isGraceClass = false;
      this.isGraceMaxPaper = false;
      this.rollNo = false;
      this.loadGrid(e,SnNo);
    } else if (e == 'R') {
      let payload = {};
      payload['ShId'] = ''
      payload['PartProc'] = ''
      this.title = "Process Results "
      this.title_one = "Processes Results"
      this.title_two = "Pass / Fail, Class/Division, Exemption"
      this.title_three = "This process can be repeated, if data Changes"
      this.isBranch = true;
      this.rollNo = false;
      this.loadDynamic();
      // this.loadBranchList(payload, this.MenuCode);
      this.loadGrid(e,SnNo);
    } else if (e == 'U') {
      this.title = "Update Results  "
      this.title_one = "Update results to course master "
      this.title_two = "This process can not be repeated or reversed "
      this.title_three = "Preferably, Take a Backup "
      this.isBranch = false;
      this.isDistrict = false;
      this.isGrace = false;
      this.isGraceClass = false;
      this.isGraceMaxPaper = false;
      this.rollNo = false;
      this.loadGrid(e,SnNo);
    } else if (e == 'RP') {
      this.title = "Re-Process Results For Changes Only "
      this.title_one = "Process results"
      this.title_two = "for only those candidates whose information has changed since last processing"
      this.title_three = ""
      this.isBranch = false;
      this.isDistrict = false;
      this.isGrace = false;
      this.isGraceClass = false;
      this.isGraceMaxPaper = false;
      this.rollNo = false;
      this.loadGrid(e,SnNo);
    } else if (e == ' ') {
      this.title = "Center Codes"
      this.title_one = "Title one Header"
      this.title_two = "Title two Header"
      this.title_three = "Title three  Header"
      this.isBranch = false;
      this.isDistrict = false;
      this.isGrace = false;
      this.isGraceClass = false;
      this.isGraceMaxPaper = false;
      this.rollNo = false;
    }
  }

  submit() {
  }
  // keypress() {

  // }
  loadDynamic() {
    // this.umsService.secretdata['SnNo']
    let mysecritdata = this.umsService.secretdata['ResParam'];
    let codeArray = mysecritdata.split(",");
    codeArray.forEach(element => {
      if (element == 'D') {
        this.isBranch = false;
        this.isDistrict = true;
      } else if (element == 'G') {
        this.isGrace = true;
      } else if (element == 'C') {
        this.isGraceClass = true;
      } else if (element == 'N') {
        this.isGraceMaxPaper = true;
      }
    });

  }

  loadBranchList(e, MenuCode) {
    this.getExamData(e.EmId);
    this.GLO_ShId = e.ShId;
    this.Count = e.Cnt
    this.selectedRowValue = e;
    if (MenuCode == 'R' || MenuCode == 'RP' || MenuCode == 'U') {
      let payload = {}
      payload['ShId'] = e.ShId;
      this.GLO_ShId = e.ShId;
      if (e.PartProc !== 0) {
        payload['SsProc'] = 'N';
      }
      e['StrId'] = 0;
      //  called nilesh meeting timebeeing
      //   this.umsService.getResultBranchDistrictList(payload).subscribe((res) => {
      //     if (res.status) {
      //       this.BranchDistrictList = res.data
      //       this.filteredBranchDistrictList = this.BranchDistrictList.slice();
      //     } else {
      //       this.BranchDistrictList = []
      //       this.filteredBranchDistrictList = this.BranchDistrictList.slice();
      //     }
      //   },(ERROR: HttpErrorResponse) => {
      //     this.BranchDistrictList = []
      //     this.filteredBranchDistrictList = this.BranchDistrictList.slice();
      //  });
      //  this.loadGraceValues(e);

      this.resultForm.controls['Exam'].setValue(e.EmName);
      //  called nilesh meeting timebeeing
    } 
    else if(MenuCode == 'O'){
      this.resultForm.controls['Exam'].setValue(e.EmName);
      this.resultForm.controls['RollNo'].setValue(1)
    }
    else {
      this.resultForm.controls['Exam'].setValue(e.EmName);
    }
  }

getExamData(EmId) {
  let payload = {}
  // payload['EmCoCode'] = e.EmCoCode;
    payload['EmId'] = EmId;
  this.umsService.getExam(payload).subscribe((res) => {
    if (res.status) {
      res.data[0].EmCoCode
      this.getCourseData(res.data[0].EmCoCode);
    } else {
     ;
    }
  }, (ERROR: HttpErrorResponse) => {
   
  });
}
getCourseData(cocode){
  let payload = {}
  // payload['EmCoCode'] = e.EmCoCode;
    payload['CoCode'] = cocode;
  this.umsService.getCourse(payload).subscribe((res) => {
    if (res.status) {
   this.RollNoPrfx= res.data[0].RollNoPrfx
      
    } else {
     ;
    }
  }, (ERROR: HttpErrorResponse) => {
   
  });
}
  loadGraceValues(e) {
    this.spinner.show();
    let payload = {}
    payload['ShId'] = e.ShId;
    payload['StrId'] = e.StrId;
    this.umsService.getResultGridList(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        let mysecritdata = this.umsService.secretdata['ResParam'];
        let codeArray = mysecritdata.split(",");
        codeArray.forEach(element => {
          if (element == 'G') {
            this.resultForm.controls['grace'].setValue(res.data['AcptGrace']);
          } else if (element == 'C') {
            this.resultForm.controls['classGrace'].setValue(res.data['AcptClGrace ']);
          } else if (element == 'N') {
            this.resultForm.controls['maxClassGrace'].setValue(res.data['GraceSub']);
          }
        });
      } else {
        this.spinner.hide();
        // this.resultList = []
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      // this.resultList = []
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.loadGrid(this.MenuCode,this.SessionNo);
    // this.keypress()
  }
  loadGrid(e,SnNo) {
    this.spinner.show();
    let payload = {}
    payload['SnNo'] = SnNo;
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['code'] = e;
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getResultGridList(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.resultList = res.data
        this.totalItems = res.data[0].TotalRecords;
      } else {
        this.spinner.hide();
        this.resultList = []
        this.totalItems = 0
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.resultList = []
      this.totalItems = 0
    });
  }

  
  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.resultList = [];
      const payload = {};
      payload['SnNo'] = this.SessionNo;
      payload['LoginId'] = sessionStorage.getItem('userId');
      payload['PageSize'] = this.pageSize;
      payload['code'] = this.MenuCode;
      payload['SearchString'] = this.resultSearchForm.value['SearchString'];
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.getResultGridList(payload).subscribe(
        (res) => {
          if(res.status){
            this.resultList = res.data;
            this.totalItems = res.data[0].TotalRecords;
          }
          else{
            this.resultList = [];
          this.totalItems = 0
          }
         
          }, (ERROR: HttpErrorResponse) => {
          this.resultList = [];
          this.totalItems = 0
        });
    },1000)
    
  }

  validateRecords() {
    this.spinner.show()
    if (this.resultForm.get('Exam').valid) {
      if (this.MenuCode == 'R' || this.MenuCode == 'C' || this.MenuCode == 'F' || this.MenuCode == 'D' || this.MenuCode == 'RP' || this.MenuCode == 'O' || this.MenuCode == 'U') {
        if (this.selectedRowValue.OpenLists > 0) {
          this.spinner.hide()
          this.gstrVldtMesg = "Input List are Open";
          let data = {};
          data['message'] = this.gstrVldtMesg;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          return false;
        } 
        else if (this.Count == 0) {
          this.spinner.hide()
          this.gstrVldtMesg = "Student Count Is Zero";
          let data = {};
          data['message'] = this.gstrVldtMesg;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          return false;
        } 
        else {
          if (this.MenuCode == 'R' && this.gstrVldtMesg == '') {
            this.spinner.show();
            let payload = {}
            payload['ShId'] = this.GLO_ShId;
            payload['BrId'] = 0;
            this.umsService.ValidateRecordsS(payload).subscribe((res) => {
              if (res.status && res.message !== '') {
                this.spinner.hide()
                this.gstrVldtMesg = res.message;
                let data = {};
                data['message'] = this.gstrVldtMesg;
                data['title'] = 'Information';
                data['icon'] = 'fas fa-check';
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                return false;
                //  this.gstrVldtMesg = res.message;
                // let data = {};
                // data['message'] = this.gstrVldtMesg + ', Proceed?';
                // data['title'] = 'Process Result';
                // data['icon'] = 'fa fa-question';
                // this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
                // this.dialogRef.afterClosed().subscribe(result => {
                //   if (result === 'yes') {
                //     this.gstrVldtMesg = ''
                //     this.procced();
                //     return true;
                //   } else {
                //     this.gstrVldtMesg = 'Processing Cancelled'
                //     let data = {};
                //     data['message'] = this.gstrVldtMesg;
                //     data['title'] = 'Information';
                //     data['icon'] = 'fas fa-close';
                //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                //     return false;
                //   }
                // });
              } else {
                this.spinner.hide()
                this.procced();
              }
            }, (ERROR: HttpErrorResponse) => {
              this.spinner.hide()
              this.gstrVldtMesg = "API Error Message";
              let data = {};
              data['message'] = this.gstrVldtMesg;
              data['title'] = 'Alert';
              data['icon'] = 'fas fa-close';
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              return false;
            });
          }
          else if(this.MenuCode == 'RP'){
            this.spinner.show();
            let payload = {}
            payload['ShId'] = this.GLO_ShId;
            payload['StrId'] = 0;
            payload['DsCode'] = '';
            payload['ReProc'] = 'Y';
            payload['Inst'] = this.umsService.secretdata['ClubPartTrans'];
            payload['AcptGrace'] = 0;
            payload['AcptClGrace'] = 0;
            payload['GraceSub'] = 0;
            payload['LowExam'] = this.umsService.secretdata['LowExam'];
            payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
            this.umsService.VldtRecordRP(payload).subscribe((res) => {
              if (res.status && res.message !== '') {
                this.spinner.hide()
                this.gstrVldtMesg = res.message;
                let data = {};
                data['message'] = this.gstrVldtMesg;
                data['title'] = 'Information';
                data['icon'] = 'fas fa-check';
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                this.loadGrid('RP',this.SessionNo)
                this.dialogRef.afterClosed().subscribe((result) => {
                  this.ngOnInit()
                });
                return false;
                
              } else {
                this.spinner.hide()
                // this.procced();
              }
            }, (ERROR: HttpErrorResponse) => {
              this.spinner.hide()
              // this.gstrVldtMesg = res.message;
              let data = {};
              data['message'] = ERROR.error.message;
              data['title'] = 'Information';
              data['icon'] = 'fas fa-close';
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              return false;
            });
          }
          else if(this.MenuCode == 'U'){
            this.spinner.show()
            let payload = {} 
            payload['ShId'] = this.GLO_ShId;
            payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
            this.umsService.VldtRecordU(payload).subscribe((res) => {
              if(res.status){
                if (res.status && res.message !== '') {
                  this.gstrVldtMesg = res.message;
                  this.spinner.hide()
                  let data = {};
                  data['message'] = this.gstrVldtMesg;
                  data['title'] = 'Information';
                  data['icon'] = 'fas fa-check';
                  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                  this.loadGrid('U',this.SessionNo)
                  this.dialogRef.afterClosed().subscribe((result) => {
                    this.ngOnInit()
                  });
                  return false;
                } else {
                  // this.procced();
                  this.spinner.hide()
                }
              }
              else{
                this.spinner.hide()
              }
             
            }, (ERROR: HttpErrorResponse) => {
              // this.gstrVldtMesg = res.message;
              this.spinner.hide()
              let data = {};
              data['message'] = ERROR.error.message;
              data['title'] = 'Alert';
              data['icon'] = 'fas fa-close';
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              return false;
            });

          }
          else if(this.MenuCode == 'C'){
            this.spinner.hide()
          }
          else if(this.MenuCode == 'D'){
            this.spinner.hide()
            let payload = {}
            payload['ShId'] = this.GLO_ShId;
            payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
          }
          else if(this.MenuCode == 'F'){
            this.spinner.hide()
          }
          else if(this.MenuCode == 'O'){
            this.spinner.show()
            let payload = {}
            this.SessionYear.slice(-2)
            payload['ShId'] = this.GLO_ShId;
            payload['Inst'] = this.umsService.secretdata['ClubPartTrans'];
            payload['RollNo'] = parseInt(this.resultForm.value.RollNo);
            payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
            payload['RollNoPrfx'] = this.RollNoPrfx + this.SessionYear.slice(-2)
            this.umsService.VldtRecordRollNo(payload).subscribe((res) => {
              if (res.status && res.message !== '') {
                this.spinner.hide()
                this.gstrVldtMesg = res.message;
                let data = {};
                data['message'] = this.gstrVldtMesg;
                data['title'] = 'Information';
                data['icon'] = 'fas fa-check';
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                this.dialogRef.afterClosed().subscribe((result) => {
                  this.ngOnInit()
                  this.loadGrid('O',this.SessionNo);
                });
                
                return false;
                
              } else {
                this.spinner.hide()
                // this.procced();
              }
            }, (ERROR: HttpErrorResponse) => {
               this.spinner.hide();
              // this.gstrVldtMesg = res.message;
              let data = {};
              data['message'] = ERROR.error.message;
              data['title'] = 'Alert';
              data['icon'] = 'fas fa-close';
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              return false;
            });
          }
          else {
            this.spinner.hide()
            this.gstrVldtMesg = ''
            return true;
          }
        }
      }
      else{
        this.spinner.hide()
      }
    } else {
      this.spinner.hide()
      this.gstrVldtMesg = "Select Exam";
      let data = {};
      data['message'] = this.gstrVldtMesg;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return false;
    }
  }

  ValidateAndProcess1() {
    this.spinner.show();
    this.gstrVldtMesg = '';
    let Code_R_Payload = {};
    Code_R_Payload['ShId'] = this.GLO_ShId;
    Code_R_Payload['StrId'] = 0;
    Code_R_Payload['DsCode'] = '';
    Code_R_Payload['ReProc'] = '';
    // Code_R_Payload['Inst'] = parseInt(sessionStorage.getItem('Inst'));
    Code_R_Payload['Inst'] ='7';
    Code_R_Payload['AcptGrace'] = parseInt('0');
    Code_R_Payload['AcptClGrace'] = parseInt('0');
    Code_R_Payload['GraceSub'] = parseInt('0');
    Code_R_Payload['LowExam'] = this.umsService.secretdata['LowExam'];
    Code_R_Payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
    this.umsService.submitCode_R_(Code_R_Payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.gstrVldtMesg = res.message;
        let data = {};
        data['message'] = this.gstrVldtMesg;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else {
        this.spinner.hide();
        this.gstrVldtMesg = res.message;
        let data = {};
        data['message'] = this.gstrVldtMesg;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.gstrVldtMesg = ERROR.message;
        let data = {};
        data['message'] = this.gstrVldtMesg;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      })
  }

  procced() {
    this.spinner.show()
    this.gstrVldtMesg = '';
    if (this.MenuCode == 'R') {
      let Code_R_Payload = {};
      Code_R_Payload['ShId'] = this.GLO_ShId;
      Code_R_Payload['StrId'] = 0;
      Code_R_Payload['DsCode'] = '';
      Code_R_Payload['ReProc'] = '';
      // Code_R_Payload['Inst'] = parseInt(sessionStorage.getItem('Inst'));
      Code_R_Payload['Inst'] ='7';
      Code_R_Payload['AcptGrace'] = 0;
      Code_R_Payload['AcptClGrace'] = 0;
      Code_R_Payload['GraceSub'] = 0;
      Code_R_Payload['LowExam'] = this.umsService.secretdata['LowExam'];
      Code_R_Payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
      this.umsService.submitCode_R_(Code_R_Payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.gstrVldtMesg = res.message;
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.ngOnInit();
        } else {
          this.spinner.hide();
          this.gstrVldtMesg = res.message;
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.gstrVldtMesg = ERROR.error.message;
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Alert';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        })
    }
    //   let scheduleLockPayload = {};
    //   scheduleLockPayload['ShId'] = this.GLO_ShId;
    //   scheduleLockPayload['LoginId'] = sessionStorage.getItem('userId');
    //   alert("check point 3 triggred")
    //  this.umsService.scheduleLockInit(scheduleLockPayload).subscribe((res) => {
    //    if (res.status && res.message == '') {

    // }
    // })
  }

  ValidateAndProcess() {
    let submitpayload = {};
    submitpayload['lnBr'] = 0;
    submitpayload['strDsCode'] = '';
    if (this.isDistrict == true) {
      submitpayload['strDsCode'] = this.resultForm.value.district;
    } else {
      submitpayload['lnBr'] = parseInt(this.resultForm.value.branch);
    }
    this.validateRecords();
    this.ngOnInit();
    // if(this.validateRecords() == true){

    //    this.gstrVldtMesg = '';
    //    let scheduleLockPayload = {};
    //    scheduleLockPayload['ShId'] = this.GLO_ShId;
    //    scheduleLockPayload['LoginId'] = sessionStorage.getItem('userId');
    //   this.umsService.scheduleLockInit(scheduleLockPayload).subscribe((res) => {
    //     if (res.status && res.message == '') {
    //     if(this.MenuCode == 'R'){
    //       let Code_R_Payload = {};
    //       Code_R_Payload['ShId'] = this.GLO_ShId;
    //       Code_R_Payload['StrId'] = 0;
    //       Code_R_Payload['DsCode'] = '';
    //       Code_R_Payload['ReProc'] = '';
    //       Code_R_Payload['Inst'] = parseInt(sessionStorage.getItem('Inst'));
    //       Code_R_Payload['AcptGrace'] = parseInt('0');
    //       Code_R_Payload['AcptClGrace'] = parseInt('0');
    //       Code_R_Payload['GraceSub'] = parseInt('0');
    //       Code_R_Payload['LowExam'] = this.umsService.secretdata['LowExam'];
    //       Code_R_Payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
    //       this.umsService.submitCode_R_(Code_R_Payload).subscribe((res) => {
    //         if(res.status){
    //           this.gstrVldtMesg  = res.message;
    //           let data = {};
    //           data['message'] = this.gstrVldtMesg;
    //           data['title'] = 'Information';
    //           data['icon'] = 'fas fa-close';
    //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //         }else{
    //           this.gstrVldtMesg  = res.message;
    //           let data = {};
    //           data['message'] = this.gstrVldtMesg;
    //           data['title'] = 'Information';
    //           data['icon'] = 'fas fa-close';
    //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //         }
    //       },
    //       (ERROR: HttpErrorResponse) => {
    //         this.gstrVldtMesg  = res.message;
    //         let data = {};
    //         data['message'] = this.gstrVldtMesg;
    //         data['title'] = 'Information';
    //         data['icon'] = 'fas fa-close';
    //         this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //       })
    //     }else if (this.MenuCode == 'U') {
    //       let Code_U_Payload = {};
    //       Code_U_Payload['ShId'] = '';
    //       Code_U_Payload['LoginId'] = '';
    //       this.umsService.submitCode_U_(Code_U_Payload).subscribe(
    //         (res) => {
    //           if (res.status) {
    //             this.gstrVldtMesg = res.message;
    //             let data = {};
    //             data['message'] = this.gstrVldtMesg;
    //             data['title'] = 'Information';
    //             data['icon'] = 'fas fa-close';
    //             this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //           } else {
    //             this.gstrVldtMesg = res.message;
    //             let data = {};
    //             data['message'] = this.gstrVldtMesg;
    //             data['title'] = 'Information';
    //             data['icon'] = 'fas fa-close';
    //             this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //           }
    //         },
    //         (ERROR: HttpErrorResponse) => {
    //           this.gstrVldtMesg = "API Error Message";
    //           let data = {};
    //           data['message'] = this.gstrVldtMesg;
    //           data['title'] = 'Information';
    //           data['icon'] = 'fas fa-close';
    //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //         }
    //       );
    //     } else if (this.MenuCode == 'C') {
    //       this.gstrVldtMesg = 'Cancelled by user';
    //       let Code_C_Payload = {};
    //       Code_C_Payload['ShId'] = '';
    //       let data = {};
    //       data['id'] = { test: 'sss' };
    //       data['value'] = { test: 'sss' };
    //       this.dialogRef = this.dialog.open(
    //         GenerateControlSheetsPoPComponent,
    //         {
    //           width: '600px',
    //           height: 'auto',
    //           data,
    //         }
    //       );
    //       this.dialogRef.afterClosed().subscribe((result) => {
    //         Code_C_Payload['CollUni'] = '';
    //         Code_C_Payload['CsNo'] = result['CsNo'];
    //         Code_C_Payload['ColNo'] = result['ColNo'];
    //         if(result.action == 'yes'){
    //           this.umsService.submitCode_C_(Code_C_Payload).subscribe(
    //             (res) => {
    //               if (res.status) {
    //                 this.gstrVldtMesg = 'Control Sheets generated';
    //                 let data = {};
    //                 data['message'] = this.gstrVldtMesg;
    //                 data['title'] = 'Information';
    //                 data['icon'] = 'fas fa-close';
    //                 this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //               }
    //             },
    //             (ERROR: HttpErrorResponse) => {
    //               this.gstrVldtMesg = ERROR.message;
    //               let data = {};
    //               data['message'] = this.gstrVldtMesg;
    //               data['title'] = 'Information';
    //               data['icon'] = 'fas fa-close';
    //               this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //             }
    //           );
    //         }else{
    //           this.gstrVldtMesg = result.message;
    //           let data = {};
    //           data['message'] = this.gstrVldtMesg;
    //           data['title'] = 'Information';
    //           data['icon'] = 'fas fa-close';
    //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //         }
    //       });
    //     } else if (this.MenuCode == 'D') {
    //       let Code_D_Payload = {};
    //       Code_D_Payload['ShId'] = ''
    //       Code_D_Payload['LoginId'] = ''
    //       this.umsService.submitCode_D_(Code_D_Payload).subscribe(
    //         (res) => {
    //           if (res.status) {
    //             this.gstrVldtMesg = res.message;
    //             let data = {};
    //             data['message'] = this.gstrVldtMesg;
    //             data['title'] = 'Information';
    //             data['icon'] = 'fas fa-close';
    //             this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //           } else {
    //             this.gstrVldtMesg = res.message;
    //             let data = {};
    //             data['message'] = this.gstrVldtMesg;
    //             data['title'] = 'Information';
    //             data['icon'] = 'fas fa-close';
    //             this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //           }
    //         },
    //         (ERROR: HttpErrorResponse) => {
    //           this.gstrVldtMesg = 'API Error'
    //           let data = {};
    //           data['message'] = this.gstrVldtMesg;
    //           data['title'] = 'Information';
    //           data['icon'] = 'fas fa-close';
    //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //         }
    //       );
    //     } else if (this.MenuCode == 'RP') {
    //       let Code_RP_Payload = {};
    //       Code_RP_Payload['ShId'] = '';
    //       Code_RP_Payload['StrId'] = '';
    //       Code_RP_Payload['DsCode'] = '';
    //       Code_RP_Payload['ReProc'] = 'Y';
    //       Code_RP_Payload['Inst'] = sessionStorage.getItem('Inst');
    //       Code_RP_Payload['AcptGrace'] = parseInt('0');
    //       Code_RP_Payload['AcptClGrace'] = parseInt('0');
    //       Code_RP_Payload['GraceSub'] = parseInt('0');
    //       Code_RP_Payload['LowExam'] = this.umsService.secretdata['LowExam'];
    //       Code_RP_Payload['LoginId'] = '';
    //       this.umsService.submitCode_RP_(Code_RP_Payload).subscribe((res) => {
    //         if(res.status){
    //           this.gstrVldtMesg  = res.message;
    //           let data = {};
    //           data['message'] = this.gstrVldtMesg;
    //           data['title'] = 'Information';
    //           data['icon'] = 'fas fa-close';
    //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //         }else{
    //           this.gstrVldtMesg  = res.message;
    //           let data = {};
    //           data['message'] = this.gstrVldtMesg;
    //           data['title'] = 'Information';
    //           data['icon'] = 'fas fa-close';
    //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //         }
    //       },
    //       (ERROR: HttpErrorResponse) => {
    //         this.gstrVldtMesg  = "API Error";
    //         let data = {};
    //         data['message'] = this.gstrVldtMesg;
    //         data['title'] = 'Information';
    //         data['icon'] = 'fas fa-close';
    //         this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //       })
    //     } else if (this.MenuCode == 'F') {
    //       let Code_F_Payload = {};
    //       let data = {};
    //       data['id'] = { test: 'sss' };
    //       data['value'] = { test: 'sss' };
    //       this.dialogRef = this.dialog.open(
    //         GenerateControlSheetsPoPComponent,
    //         {
    //           width: '600px',
    //           height: 'auto',
    //           data,
    //         }
    //       );
    //       this.dialogRef.afterClosed().subscribe((result) => {
    //         Code_F_Payload[''] = ''
    //         Code_F_Payload['PerFo'] = result['Folio ']
    //         if(result.action == 'yes'){
    //           this.umsService.submitCode_F_(Code_F_Payload).subscribe(
    //             (res) => {
    //               if (res.status) {
    //                 this.gstrVldtMesg = res.message;
    //                 let data = {};
    //                 data['message'] = this.gstrVldtMesg;
    //                 data['title'] = 'Information';
    //                 data['icon'] = 'fas fa-close';
    //                 this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //               } else {
    //                 this.gstrVldtMesg = res.message;
    //                 let data = {};
    //                 data['message'] = this.gstrVldtMesg;
    //                 data['title'] = 'Information';
    //                 data['icon'] = 'fas fa-close';
    //                 this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //               }
    //             },
    //             (ERROR: HttpErrorResponse) => {
    //               this.gstrVldtMesg = 'API Error';
    //               let data = {};
    //               data['message'] = this.gstrVldtMesg;
    //               data['title'] = 'Information';
    //               data['icon'] = 'fas fa-close';
    //               this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //             }
    //           );
    //         }else{
    //           this.gstrVldtMesg = result.message;
    //           let data = {};
    //           data['message'] = this.gstrVldtMesg;
    //           data['title'] = 'Information';
    //           data['icon'] = 'fas fa-close';
    //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //         }
    //       });
    //     } else if (this.MenuCode == 'O') {
    //       let Code_O_Payload = {};
    //       let data = {};
    //       data['id'] = { test: 'sss' };
    //       data['value'] = { test: 'sss' };
    //       this.dialogRef = this.dialog.open(
    //         GenerateControlSheetsPoPComponent,
    //         {
    //           width: '600px',
    //           height: 'auto',
    //           data,
    //         }
    //       );
    //       this.dialogRef.afterClosed().subscribe((result) => {
    //         Code_O_Payload['ShId'] = ""
    //         Code_O_Payload['RollNo'] = result['result']
    //         Code_O_Payload['LoginId'] = ""
    //         Code_O_Payload['Inst'] =  sessionStorage.getItem('Inst');
    //         if(result.action == 'yes'){
    //           this.umsService.submitCode_O_(Code_O_Payload).subscribe(
    //             (res) => {
    //               if (res.status) {
    //                 this.gstrVldtMesg = res.message;
    //                 let data = {};
    //                 data['message'] = this.gstrVldtMesg;
    //                 data['title'] = 'Information';
    //                 data['icon'] = 'fas fa-close';
    //                 this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //               } else {
    //                 this.gstrVldtMesg = res.message;
    //                 let data = {};
    //                 data['message'] = this.gstrVldtMesg;
    //                 data['title'] = 'Information';
    //                 data['icon'] = 'fas fa-close';
    //                 this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //               }
    //             },
    //             (ERROR: HttpErrorResponse) => {
    //               this.gstrVldtMesg = 'API Error';
    //               let data = {};
    //           data['message'] = this.gstrVldtMesg;
    //           data['title'] = 'Information';
    //           data['icon'] = 'fas fa-close';
    //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //             }
    //           );
    //         }else{
    //           this.gstrVldtMesg = result.message;
    //           let data = {};
    //           data['message'] = this.gstrVldtMesg;
    //           data['title'] = 'Information';
    //           data['icon'] = 'fas fa-close';
    //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //         }
    //       });
    //     }

    //     let endScheduleLockPayload = {};
    //     // validate the input
    //     endScheduleLockPayload['lnShId'] = 'lnShId';
    //     endScheduleLockPayload['LoginID'] = 'lnShId';
    //     // call scheduleLock end api have to change the url once chnaged pls fuck remove it
    //     this.umsService.getResultGridList(endScheduleLockPayload).subscribe((res) => {
    //       this.gstrVldtMesg = res.message;
    //       let data = {};
    //       data['message'] = this.gstrVldtMesg;
    //       data['title'] = 'Information';
    //       data['icon'] = 'fas fa-close';
    //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //       },(ERROR: HttpErrorResponse) => {
    //       this.gstrVldtMesg = "API Error Message";
    //       let data = {};
    //       data['message'] = this.gstrVldtMesg;
    //       data['title'] = 'Information';
    //       data['icon'] = 'fas fa-close';
    //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //     })
    //     // call scheduleLock end api
    //     } else {
    //       // headder add alert = Process
    //       this.gstrVldtMesg = res.message;
    //       let data = {};
    //       data['message'] = this.gstrVldtMesg;
    //       data['title'] = 'Information';
    //       data['icon'] = 'fas fa-close';
    //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //     }
    //   },(ERROR: HttpErrorResponse) => {
    //     this.gstrVldtMesg = "API Error Message";
    //     let data = {};
    //     data['message'] = this.gstrVldtMesg;
    //     data['title'] = 'Information';
    //     data['icon'] = 'fas fa-close';
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //  });
    //   // call api end
    // }else{
    //   this.spinner.show();
    // }
  }

}